
import { Component, Vue } from 'vue-property-decorator'

import UIkit from 'uikit'
import VueRecaptcha from 'vue-recaptcha'

import BacHeader from '@/templates/BacHeader.vue'
import { Http } from '@/lib/utils/Http'

@Component({
  components: {
    BacHeader,
    VueRecaptcha
  }
})
export default class Forget extends Vue {
  email = ''
  captchaToken = 'token'
  successfullySent = false

  onCaptchaVerify (token: string) {
    this.captchaToken = token
  }

  async send () {
    const res = await Http.request('/api/user/forgot-password', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: this.email,
        captchaToken: this.captchaToken
      })
    })
    const resData = await res.json()
    if (resData.error) {
      let error = 'Ein unbekannter Fehler ist aufgetreten! Bitte wende dich an hello@backroadclub.com'
      if (resData.error === 'invalid-captcha') {
        error = 'Bitte fülle das Captcha aus!'
      } else if (resData.error === 'invalid-email') {
        error = 'Es wurde kein Nutzer mit dieser E-Mail Adresse gefunden!'
      }
      UIkit.notification({
        message: error,
        status: 'success',
        timeout: 5000,
        pos: 'bottom-center'
      })
      return
    }
    this.successfullySent = true
  }
}
